import { createClient } from '@supabase/supabase-js';

const rawSupabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const rawSupabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

function validateSupabaseConfig(urlValue, anonKeyValue) {
  const url = String(urlValue || '').trim();
  const anonKey = String(anonKeyValue || '').trim();

  if (!url || !anonKey) {
    return 'Missing Supabase configuration. Create a .env file in the project root with REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY, then restart npm start.';
  }

  let parsed;
  try {
    parsed = new URL(url);
  } catch (_error) {
    return 'Invalid REACT_APP_SUPABASE_URL. It must be the Project URL from Supabase, for example https://your-project-ref.supabase.co.';
  }

  if (!['http:', 'https:'].includes(parsed.protocol)) {
    return 'Invalid REACT_APP_SUPABASE_URL. It must start with https://, for example https://your-project-ref.supabase.co.';
  }

  const path = parsed.pathname.replace(/\/+$/, '');
  if (path && path !== '') {
    return 'Invalid REACT_APP_SUPABASE_URL. Use only the base Project URL from Supabase. Do not include /auth/v1, /rest/v1, /project, or any other path.';
  }

  if (anonKey.includes('http')) {
    return 'Invalid REACT_APP_SUPABASE_ANON_KEY. Paste only the anon public key, not the Project URL.';
  }

  return '';
}

export const supabaseConfigError = validateSupabaseConfig(rawSupabaseUrl, rawSupabaseAnonKey);
export const isSupabaseConfigured = !supabaseConfigError;

if (supabaseConfigError) {
  console.error(supabaseConfigError);
}

export const supabase = createClient(
  isSupabaseConfigured ? rawSupabaseUrl.trim() : 'https://placeholder.supabase.co',
  isSupabaseConfigured ? rawSupabaseAnonKey.trim() : 'placeholder-anon-key'
);
